import React from "react";
import "./styles.scss";

export default props => (
  <div className="more-details pt-4">
    <p><b>Full list of platforms:</b></p>
    <p className="more-details-text">
      7 Digital, 8 Tracks, Acer, Akazoo, Alibaba Xiami, Alphabet YouTube Music,
      Alphabet YouTube User, Amazon Prime Music, Anghami, Apple Music, Apple
      Shazam, Artistxite, Audible Magic, Audio Print Music, Audiojungle, AWA,
      Baidu Music, Bandcamp, BBM Shop, Beat.no, Beatport, Beatsource, Bitel,
      Bleep, BrandSpins, Broadtime, Bücher, BYO, CCI Distribution, CDON, China
      Mobile, China Telecom, Chunghwa Telecom, Claro Musica, Coca-Cola,
      Contestone/Ringbacktone, Crickery Wood, CTS/Eventim, CUR Music, Dance All
      Day, Deezer, Digicel, Digster, Discjam, Dubset, Electric Jukebox, Emusic,
      Ex Libris, Facebook, Fan Label, FETnet, Findspire, Flipagram, Fnac, Forest
      Incentives, FreeCarmen/Trebel Music, Freeform, FUHU Nabi 2, Gaana, Global
      Radio, Global Tel, Google Play, Grandpad, Grruv, Gruvera, Hardstyle.com,
      Heat Music, High Res Audio, hmv PLAY, HTC One, Huashu, Huawei Music, I
      Like Music/Mixpixie, iam+Dial, iHeartRadio, ImageSound, Imbee, iTunes,
      IVR, Jaxsta, JB Hi-Fi, Jeoutai, JioSaavn, JoMedia, Juke, Keefe Group,
      KKBOX, Klassik Radio, Kleek, Kobo, Kolbi, Kontor, KTV, Kuack Media, La
      Musica SBS, La Poste Mobile, Last.fm, LifeScape, Line Music, Mach by
      Mariposa, Me2u Music, Media Markt, Mi Tracks, Microsoft XBOX Groove, Mix
      Up, Mix Cloud, Mixette, Mobilcom/Debitel, Movistar, MUMO, Mus.uy,
      MusicJet, MusicQubed, MusicStation, Muzu, My Playlist, myMusic, Napster,
      NEC, NetEase Cloud Music, Neurotic Media, NicheStreem, nMusic, Now Music
      A1/Mtel/Vip, NSM, Omnifone, Omusic, Onkyo Music, Open Live, Orange,
      Overmax, Playster, Pledge, Pono, Prizm, Prodigium/Infogo, Psonar, Pubbles,
      Pulselocker, QNX CAR, Qobuz, R&R, Raku, Rara, RcrdClub, Rdio/Dhingana,
      Rhino/Warner, Rithm, ROK mobile, Sainsburys, Saturn, Simfy, SiriusXM
      Pandora, Slacker, Songa, Sony Music Unlimited, Soundday, SoundCloud Go,
      Soundtrack Your Band, Spark.dj, Spinlet, Spotify, Sunrise, SuperCloud,
      Taiwan Mobile, TDC, Technics Tracks, Telmore Musik, Tencent, Tesla, The
      First Club, The Overflow, Tidal, TikTok, Tonlist, Tonspion, ToonGoggles,
      Toutiao, Trackdrip, Transsnet Boomplay, Triplay, TSTAR, Tuned Global,
      Tunewiki, Turkcell Fizy, UMG Popup Stores, United Media Agency, Univision,
      Virgin Mobile, Viva, Vodafone, Walkgame, Weltbild/A&M, Xiaomi Music,
      Yandex Music, Yinyuetai, Yiqixiu, Yonder, You42, YouMusic, Zonga, Zvooq
    </p>
    <button
      className="my-3 px-5 text-uppercase btn btn-md btn-primary"
      onClick={props.onBack}
    >
      Back
    </button>
  </div>
);
